import React from "react";

const JumboLayoutContentContext = React.createContext({});

export default JumboLayoutContentContext;
